import { ArrowLeftToLine } from "lucide-react";

const ArrowLeftComponent = ({ onClick, className }) => {
    return (
        <ArrowLeftToLine
            className={className || "w-4 h-4"}
            onClick={onClick ? () => {
                onClick();
            } : undefined}
        />
    );
}

export default ArrowLeftComponent;